<template>
  <v-card style="width: 75vw; margin: 32px auto">
    <div class="d-flex align-start" style="padding: 24px">
      <h2 class="mr-auto">Workspaces</h2>
      <Tooltip :message="tooltipMessage"></Tooltip>
    </div>
    <v-row class="d-flex align-center mx-5 mb-3">
      <v-col cols="8">
        <v-text-field v-model="search" label="Search" hide-details clearable></v-text-field>
      </v-col>
      <v-col cols="3">
        <v-btn color="white" @click="newitem()"><v-icon medium class="py-2 mr-2">mdi-plus</v-icon> New</v-btn>
      </v-col>
    </v-row>
    <v-data-table
      :search="search"
      dense
      :headers="headers"
      :items="tableItems"
      class="elevation-1"
      :items-per-page="-1"
    >
      <template v-slot:item="{ item }">
        <tr
          @click="editItem(item)"
          class="table-hover"
          :class="{ 'last-selected-row': idOfLastSelectedRow === item.id }"
        >
          <td class="row-text-no-wrap">
            {{ item.name }}
          </td>
          <td class="row-text-no-wrap">
            {{ item.primaryContactFullName }}
          </td>
          <td></td>
          <td>
            <div style="display: flex; align-items: center; justify-content: center">
              <v-tooltip text="Delete" location="top" :open-delay="tooltipOpenDelayDataTable">
                <template v-slot:activator="{ props }">
                  <div v-bind="props" @click.stop="deleteItem(item)" class="data-table-button">
                    <v-icon color="grey-darken-1" size="30px">mdi-delete</v-icon>
                  </div>
                </template>
              </v-tooltip>
            </div>
          </td>
        </tr>
      </template>
    </v-data-table>
    <v-dialog v-model="dialog" max-width="800px" eager>
      <v-card>
        <v-card-title>
          <span class="headline">{{ this.editedItem.id === 0 ? "New" : "Edit" }} - Workspace</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-form autocomplete="off" v-model="isFormValid" ref="workspaceform">
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    v-model="editedItem.name"
                    required
                    label="Workspace Name"
                    :rules="reqRules"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-autocomplete
                    required
                    :rules="reqRules"
                    auto-select-first
                    item-value="id"
                    :item-title="getUserFullName"
                    v-model="userSelected"
                    :items="userItems"
                    label="Primary User"
                    return-object
                  ></v-autocomplete>
                </v-col>
              </v-row>
              <v-row style="padding-bottom: 22px">
                <v-col class="d-flex" cols="12" style="align-items: center">
                  <v-btn tile outlined @click="newImageDialog = true"
                    ><v-icon medium class="py-2 mr-2">mdi-upload</v-icon>Upload logo</v-btn
                  >
                  <p
                    v-if="this.uploadedImage != null"
                    style="margin: auto; margin-right: 6px; margin-left: 12px; font-size: medium"
                  >
                    {{ this.uploadedImage.filename }}
                  </p>
                  <v-icon
                    v-if="this.uploadedImage != null"
                    @click="
                      clearFileInput();
                      editedItem.imagePath = null;
                    "
                    >mdi-close</v-icon
                  >
                </v-col>
              </v-row>
              <v-row v-if="this.mappedOrganization?.useEntraIdSSO">
                <v-col cols="12">
                  <v-checkbox
                    v-model="isEntraIdWorkspace"
                    hide-details
                    color="green-lighten-1"
                    label="Enable Workspace to Entra Id group link"
                  ></v-checkbox>
                </v-col>
                <v-col class="d-flex" cols="12" style="align-items: center">
                  <v-text-field
                    v-if="this.isEntraIdWorkspace"
                    required
                    :rules="reqRules"
                    v-model="editedItem.entraGroupId"
                    label="Entra Group ID"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <div style="display: flex; padding: 0 0 0 12px; gap: 4px">
                    <h3 style="font-weight: normal; padding-bottom: 0">System inventory types</h3>
                    <v-icon id="system-inventory-types-tooltip-activator" style="cursor: pointer"
                      >mdi-help-circle-outline</v-icon
                    >
                  </div>
                  <v-menu
                    :open-on-click="true"
                    :close-on-content-click="false"
                    :open-delay="100"
                    activator="#system-inventory-types-tooltip-activator"
                  >
                    <v-card max-width="500">
                      <v-card-text>
                        <div v-html="tooltipSystemInventoryTypes"></div>
                      </v-card-text>
                    </v-card>
                  </v-menu>
                </v-col>
                <v-col cols="12">
                  <v-data-table
                    style="max-height: 500px; overflow-y: auto"
                    class="elevation-1"
                    hide-default-footer
                    :items-per-page="-1"
                    v-model="selectedSystemInventoryTypes"
                    item-value="id"
                    :items="systemInventoryTypes"
                    return-object
                    :item-selectable="
                      (value) =>
                        !systemInventoryTypeWorkspaceJoins.some((sitwj) => value.id == sitwj.systemInventoryType.id)
                    "
                    :headers="headersSystemInventoryTypes"
                    disable-pagination
                    show-select
                    dense
                  >
                    <template v-slot:[`header.data-table-select`]="{ allSelected, selectAll, someSelected }">
                      <v-checkbox-btn
                        v-if="
                          systemInventoryTypes.some(
                            (sit) =>
                              !systemInventoryTypeWorkspaceJoins.some((sitwj) => sit.id == sitwj.systemInventoryType.id)
                          )
                        "
                        :indeterminate="someSelected && !allSelected"
                        :model-value="allSelected"
                        color="green-lighten-1"
                        @update:model-value="selectAll"
                      ></v-checkbox-btn>
                      <v-checkbox-btn v-else disabled :model-value="true"></v-checkbox-btn>
                    </template>
                    <template v-slot:[`item.data-table-select`]="{ internalItem, isSelected, toggleSelect }">
                      <v-checkbox-btn
                        v-if="
                          !systemInventoryTypeWorkspaceJoins.some(
                            (sitw) => sitw.systemInventoryType.id == internalItem.value.id
                          )
                        "
                        :model-value="isSelected(internalItem)"
                        color="green-lighten-1"
                        @update:model-value="toggleSelect(internalItem)"
                      ></v-checkbox-btn>
                      <v-checkbox-btn v-else :model-value="true" disabled></v-checkbox-btn>
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn tile outlined class="mb-3" @click="dialog = false"
            ><v-icon small class="py-2 mr-1">mdi-close</v-icon> Cancel</v-btn
          >
          <v-btn tile outlined class="mb-3 mr-3" @click="save()" :disabled="!isFormValid"
            ><v-icon small class="py-2 mr-1">mdi-content-save</v-icon> Save</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="newImageDialog" max-width="600px" eager>
      <v-card>
        <v-card-title> Select image(s) </v-card-title>
        <v-container>
          <form id="image-dropbox-form" enctype="multipart/form-data" novalidate>
            <div class="dropbox">
              <input
                id="file-input"
                type="file"
                multiple
                name="photos"
                accept="image/*"
                class="input-file"
                @change="filesChange($event)"
              />
              <p v-if="!isUploadingFiles" class="upload-text">Drag your file here</p>
              <p v-if="!isUploadingFiles" class="upload-text">or click to browse.</p>
              <p v-if="!isUploadingFiles && this.uploadedImage == null" class="upload-text file-count">
                File selected:
              </p>
              <p v-if="!isUploadingFiles && this.uploadedImage != null" class="upload-text file-count">
                File selected: {{ this.uploadedImage.filename }}
              </p>
              <p v-if="isUploadingFiles" class="upload-text">Uploading image...</p>
            </div>
          </form>
        </v-container>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            tile
            outlined
            class="mb-3"
            @click="
              newImageDialog = false;
              clearFileInput();
            "
            ><v-icon small class="py-2 mr-1">mdi-close</v-icon> Cancel</v-btn
          >
          <v-btn tile outlined class="mb-3 mr-3" @click="newImageDialog = false" :disabled="!isImageFormValid"
            ><v-icon small class="py-2 mr-1">mdi-content-save</v-icon> Continue</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import { HTTP } from "@/plugins/backendAPI";
import { mapGetters } from "vuex";
// import { EventBus } from '@/store/event-bus.js'
import Tooltip from "../../components/HelpTooltip.vue";

export default {
  components: { Tooltip },
  data() {
    return {
      isEntraIdWorkspace: false,
      dialog: false,
      newImageDialog: false,
      search: "",
      footerProps: { "items-per-page-options": [50, 100] },
      headers: [
        { title: "Name", key: "name", width: 200 },
        { title: "Primary contact", key: "primaryContactFullName", width: 200 },
        { title: "", key: "", sortable: false },
        { title: "", key: "action", align: "center", sortable: false, width: 100 },
      ],
      headersSystemInventoryTypes: [{ title: "Name", key: "description" }],
      tableItems: [],
      systemInventoryTypes: [],
      selectedSystemInventoryTypes: [],
      systemInventoryTypeWorkspaceJoins: [],
      editedItem: {},
      mappedOrganization: null,
      userSelected: null,
      userItems: [],
      newItem: false,

      isUploadingFiles: false,
      uploadedImage: null,
      logoImage: null,
      workspaceId: -1,

      reqRules: [(v) => !!v || "Field is required"],
      isFormValid: false,
      isImageFormValid: false,
      idOfLastSelectedRow: 0,

      tooltipOpenDelayDataTable: 200,
      tooltipSystemInventoryTypes: "Add these system inventory types to jumpstart the creation of your workspace.",

      tooltipMessage: [
        "Workspaces",
        "Workspaces makes it possible for you to create completely new and separate instances of the Service-Me platform. Use this option if you have separate divisions or businesses with different support teams. ",
      ],
    };
  },
  watch: {
    organizationid(newValue) {
      this.getitems(newValue);
    },
    dialog(isVisible) {
      if (!isVisible) {
        setTimeout(() => {
          this.systemInventoryTypeWorkspaceJoins = [];
          this.selectedSystemInventoryTypes = [];
        }, 200);
      } else {
        if (this.editedItem.systemInventoryTypeWorkspaceJoins !== undefined) {
          this.systemInventoryTypeWorkspaceJoins = this.editedItem.systemInventoryTypeWorkspaceJoins;
        }
      }
    },
  },
  created() {
    this.getitems(this.organizationid);
    this.getSystemInventoryTypes();
  },
  computed: {
    ...mapGetters(["workspaceid", "organizationid", "workspaceitems", "loading"]),
  },
  methods: {
    async getSystemInventoryTypes() {
      this.$store.dispatch("setLoading", true);
      await HTTP.get(`/inventorytype/get/system?include-inactive=false&organization-id=${this.organizationid}`)
        .then((response) => {
          this.referenceSystemInventoryTypes = response.data;
          this.systemInventoryTypes = this.referenceSystemInventoryTypes;
        })
        .catch((e) => {
          this.systemInventoryTypes = [];
          this.$store.dispatch("showError", "Error when getting system inventory types: " + (e.response.data.message ?? e.response.data));
        })
        .finally(() => {
          this.$store.dispatch("setLoading", false);
        });
    },
    triggerSaveDialog() {
      this.dialog = true;
      setTimeout(() => {
        if (this.$refs.workspaceform) this.$refs.workspaceform.resetValidation();
      }, 50);
    },
    filesChange(e) {
      if (!e.target.files.length) {
        this.isImageFormValid = false;
        return;
      }
      this.isImageFormValid = true;
      const file = e.target.files[0];
      const reader = new FileReader();
      reader.onloadend = () => {
        const logoImageToUpload = {
          filedata: reader.result.replace("data:", "").replace(/^.+,/, ""),
          filename: file.name,
          filesize: file.size,
          filetype: file.type,
        };
        this.uploadedImage = logoImageToUpload;
      };
      reader.readAsDataURL(file);
    },
    async saveImage() {
      this.isUploadingFiles = true;

      if (this.uploadedImage.filedata != undefined) {
        this.$store.dispatch("setLoading", true);
        await HTTP.post(`/workspace/${this.workspaceId}/save/logo`, this.uploadedImage)
          .then((response) => {
            this.isUploadingFiles = false;
            this.editedItem.imagePath = response.data;
            this.newImageDialog = false;
            this.clearFileInput();
          })
          .catch((e) => {
            this.isUploadingFiles = false;
            this.clearFileInput();
            this.$store.dispatch("showError", "Error when saving: " + (e.response.data.message ?? e.response.data));
          })
          .finally(() => {
            this.$store.dispatch("setLoading", false);
          });
      }
    },
    clearFileInput() {
      this.uploadedImage = null;
      this.isImageFormValid = false;
    },
    getitems(organizationId) {
      this.$store.dispatch("setLoading", true);
      HTTP.get("/workspace/get/" + organizationId)
        .then((response) => {
          this.tableItems = response.data.mappedWorkspaces;
          this.mappedOrganization = response.data.mappedOrganization;
        })
        .catch((e) => {
          this.$store.dispatch("showError", e.response.data);
        })
        .finally(() => {
          this.$store.dispatch("setLoading", false);
        });
      HTTP.get("/workspace/getusers/" + this.organizationid)
        .then((response) => {
          this.userItems = response.data;
          this.userSelected = this.userItems.find((i) => i.id === this.editedItem.primaryContactId);
        })
        .catch((e) => {
          if (e.response.status === 404) {
            this.$store.dispatch("showError", "Not found");
          } else {
            this.$store.dispatch("showError", "Oops, something went wrong");
          }
        })
        .finally(() => {
          this.$store.dispatch("setLoading", false);
        });
    },
    save() {
      var self = this;
      self.editedItem.primaryContactId = self.userSelected.id;
      self.editedItem.primaryContactFullName = `${self.userSelected.firstname} ${self.userSelected.lastname}`;
      self.editedItem.selectedSystemInventoryTypes = self.selectedSystemInventoryTypes;
      this.$store.dispatch("setLoading", true);
      HTTP.post("/workspace/save", self.editedItem)
        .then(async (response) => {
          this.workspaceId = response.data.mappedWorkspace.id;
          if (this.uploadedImage != null) {
            await this.saveImage();
          }
          if (self.editedItem.id > 0) {
            var editedIndex = self.tableItems.findIndex((q) => q.id === response.data.mappedWorkspace.id);
            self.tableItems[editedIndex].name = response.data.mappedWorkspace.name;
            self.tableItems[editedIndex].primaryContactId = response.data.mappedWorkspace.primaryContactId;
            self.tableItems[editedIndex].primaryContactFullName = self.editedItem.primaryContactFullName;
            self.tableItems[editedIndex].imagePath =
              response.data.mappedWorkspace.imagePath === null
                ? this.editedItem.imagePath
                : response.data.mappedWorkspace.imagePath;
            self.tableItems[editedIndex].entraGroupId = response.data.mappedWorkspace.entraGroupId;
            this.isEntraIdWorkspace = response.data.mappedWorkspace.entraGroupId != null;
            self.tableItems[editedIndex].systemInventoryTypeWorkspaceJoins =
              response.data.mappedWorkspace.systemInventoryTypeWorkspaceJoins;
          } else {
            const newWorkspace = response.data.mappedWorkspace;
            this.mappedOrganization = response.data.mappedOrganization;
            newWorkspace.imagePath = this.editedItem.imagePath;
            self.tableItems.push(newWorkspace);
            self.$store.dispatch("resetSelectedOrganizationAndWorkspace");
          }
          self.clearInputField();
          self.dialog = false;
        })
        .catch((e) => {
          self.clearInputField();
          if (e?.response !== undefined && e?.response.status !== 500) {
            self.$store.dispatch("showError", "Error when saving: " + (e.response.data.message ?? e.response.data));
            return;
          }
          self.$store.dispatch("showError", "Error when saving: " + e);
        })
        .finally(() => {
          this.$store.dispatch("setLoading", false);
        });
    },
    newitem() {
      this.clearFileInput();
      this.newItem = true;
      this.editedItem = {
        id: 0,
        name: null,
        primaryContactId: 0,
        primaryContactFullName: null,
        organizationId: this.organizationid,
      };
      this.userSelected = this.userItems.find((i) => i.id === this.editedItem.primaryContactId);
      this.triggerSaveDialog();
    },
    editItem(item) {
      this.idOfLastSelectedRow = item.id;
      this.triggerSaveDialog();
      this.clearFileInput();
      if (item.imagePath != null) {
        this.uploadedImage = { filename: item.imagePath };
      }
      this.isEntraIdWorkspace = item.entraGroupId != null;
      this.editedItem = Object.assign({}, item);
      this.userSelected = this.userItems.find((i) => i.id === this.editedItem.primaryContactId);
      this.dialog = true;
      setTimeout(() => {
        if (this.$refs.workspaceform) this.$refs.workspaceform.resetValidation();
      }, 50);
    },
    deleteItem(item) {
      const self = this;
      this.$root.$ConfirmDialog
        .open(
          "Delete item",
          "Please make sure no QR codes exists in this workspace before attempting to delete.<br/><br/>All associated Inventories, Inventory Types, QR Categories, and Images will also be deleted. <br/><br/> <strong>Are you sure?</strong>",
          { color: "red" }
        )
        .then((response) => {
          if (response) {
            this.$store.dispatch("setLoading", true);
            HTTP.post("/workspace/delete", item)
              .then(() => {
                self.tableItems.splice(self.tableItems.indexOf(item), 1);
                this.$store.dispatch("resetSelectedOrganizationAndWorkspace");
              })
              .catch((e) => {
                self.$store.dispatch("showError", e.response.data);
              })
              .finally(() => {
                this.$store.dispatch("setLoading", false);
              });
          }
        });
    },
    clearInputField() {
      document.getElementById("image-dropbox-form").reset();
    },
    getUserFullName(item) {
      return `${item.firstname} ${item.lastname} (${item.email}) ${item.isSSOUser ? "(SSO)" : ""}`;
    },
  },
};
</script>
<style scoped>
.image-dialog {
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
}

.dropbox {
  display: flex;
  flex-direction: column;
  justify-content: center;
  place-items: center;

  background-color: #ebf5fb;
  width: 100%;
  height: 100px;
  border-radius: 15px;
  border: 2px solid lightgrey;
  position: relative;
}

.input-file {
  width: 100%;
  height: 100px;
  opacity: 0;
  position: absolute;
  cursor: pointer;
}

.upload-text {
  font-family: Verdana, Geneva, Tahoma, sans-serif;
  margin: 0;
  padding: 0;
}

.file-count {
  font-weight: bold;
  font-style: italic;
}

::file-selector-button {
  display: none;
}
</style>
